export default class formConfig {
  // 邀请确认
  static configList() {
    return [
      {
        title: "温馨提示",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "",
            type: "slot",
            slotName: "reminder",
            width: "100%",
          }
        ]
      },
      {
        title: "非国有资金投资建设项目直接发包备案表",
        name: "3",
        icon: "",
        formConfigList: [
          {
            label: "报建编号",
            value: "constructionNo",
          },
          {
            label: "工程名称",
            value: "prjName",
          },
          {
            label: "建设单位",
            value: "buildCorp",
          },
          {
            label: "建设单位法人代表",
            value: "corpLegal",
          },
          {
            label: "建设单位法人授权委托人",
            value: "linkMan",
            children: [
              {
                label: "授权委托人电话",
                value: "linkTel",
              }
            ]
          },
          {
            label: "招标类别",
            value: "tenderClassName",
            children: [
              {
                label: "招标内容",
                value: "tenderContentName",
              }
            ]
          },
          {
            label: "立项批准文号",
            value: "noteNumber",
            children: [
              {
                label: "工程地点",
                value: "projectSite",
              }
            ]
          },
          {
            label: "资金性质",
            value: "fundsCharacter",
            children: [
              {
                label: "资金来源及落实情况",
                value: "fundsSources",
              }
            ]
          },
          {
            label: "房屋建筑工程建筑面积（㎡）",
            value: "constructionArea",
            children: [
              {
                label: "结构层次",
                value: "structuralHierarchy",
              }
            ]
          },
          {
            label: "市政工程规模",
            value: "municipalProjectScale",
          },
          {
            label: "其它工程规模",
            value: "otherProjectScale",
          },
          {
            label: "施工单位",
            value: "constructionUnitName",
            children: [
              {
                label: "企业资质类别及等级",
                value: "qualificationCategories",
              }
            ]
          },
          {
            label: "项目负责人",
            value: "projectManagerName",
            children: [
              {
                label: "项目负责人安全生产考核合格证书编号",
                value: "managerCertificateNumber",
              }
            ]
          },
          {
            label: "专职安全生产管理人员姓名",
            value: "managementCertificateName",
            children: [
              {
                label: "专职安全生产管理人员安全生产考核合格证书编号",
                value: "managementCertificateNumber",
              }
            ]
          },
          {
            label: "计划工期（日历天）",
            value: "planTimeLimit",
            children: [
              {
                label: "工程造价（万元）",
                value: "projectCost",
              }
            ]
          },
          {
            label: "发包范围",
            value: "contractScope",
          },
          {
            label: "是否联合体",
            value: "isUnionName",
          },
        ]
      },
      {
        title: "其他单位信息",
        name: "4",
        icon: "",
        formConfigList: [
          {
            label: "勘察单位",
            value: "econUnitName",
          },
          {
            label: "勘察单位项目负责人",
            value: "econProjectManagerName",
            children: [
              {
                label: "勘察工程造价（万元）",
                value: "econProjectCost",
              }
            ]
          },
          {
            label: "设计单位",
            value: "designUnitName",
          },
          {
            label: "设计单位项目负责人",
            value: "designProjectManagerName",
            children: [
              {
                label: "设计工程造价（万元）：",
                value: "designProjectCost",
              }
            ]
          },
          {
            label: "监理单位",
            value: "superUnitName",
          },
          {
            label: "监理单位项目负责人",
            value: "superProjectManagerName",
            children: [
              {
                label: "监理工程造价（万元）",
                value: "superProjectCost",
              }
            ]
          },
        ]
      },
      {
        title: "联合体单位信息",
        name: "5",
        icon: "",
        formConfigList: [
          {
            label: "",
            slotName: "unionList",
          },
        ]
      },
      {
        title: "联合体协议扫描件",
        name: "6",
        icon: "",
        formConfigList: [
          {
            label: "扫描件：",
            type: "slot",
            slotName: "uploadUnionFile"
          }
        ]
      },
      {
        title: "工程施工单位项目管理机构配备情况",
        name: "7",
        icon: "",
        formConfigList: [
          {
            label: "",
            slotName: "logList",
          },
        ]
      },
      {
        title: "非国有资金投资建设项目发包承诺书",
        name: "8",
        icon: "",
        formConfigList: [
          {
            label: "",
            slotName: "letter",
          },
        ]
      },
      {
        title: "备注",
        name: "9",
        icon: "",
        formConfigList: [
          {
            label: "备注",
            value: "remarks",
          },
        ]
      },
      {
        title: "直接发包备案记录",
        name: "10",
        icon: "",
        formConfigList: [
          {
            slotName: "recordDirectlyLog",
          },
        ]
      },
      {
        title: "核验",
        name: "11",
        icon: "",
        formConfigList: [
          {
            slotName: "auditOpinion",
          }
        ]
      },
    ];
  }
}
